import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Debt } from './debt.model';
import { DebtService } from './debt.service';

@Injectable()
export class DebtResolver implements Resolve<Debt> {
  constructor(private debtService: DebtService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Debt> {
    return this.debtService.getById(route.paramMap.get('debtId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/debts/debt.resolver.ts